// i18n for the shared base components/composables ported from myq-st-front-end
// (BaseDialogBox, BaseFilePreview, useValidationRules). Keys are prefixed `itr-` (Internally created Training
// Records) because domain files merge into one flat global namespace.
const en = {
  // shared
  'itr-search': 'Search',
  'itr-delete': 'Delete',
  // BaseDialogBox
  'itr-close': 'Close',
  'itr-save': 'Save',
  // BaseFilePreview
  'itr-preview': 'Preview',
  'itr-open-in-new-tab': 'Open in new tab',
  'itr-download': 'Download',
  'itr-preview-not-available': 'PREVIEW NOT AVAILABLE',
  'itr-file-preview': 'File Preview',
  // grid actions column
  'itr-actions': 'Actions',
  // useValidationRules
  'itr-invalid-date-format':
    'Invalid date format. Use {format} and make sure to use valid values.',
  'itr-attachment-size-limit': 'Attachment size must be less than 50MB.',
  'itr-invalid-phone-number': 'Invalid phone number. Use ###-###-####.',
  'itr-invalid-email': 'Invalid e-mail.',
  'itr-required': 'Required.',
  'itr-date-not-future': 'Date cannot be in the future.',
  'itr-invalid-time-format':
    'Invalid time format. Use dd:hh:mm and make sure to use valid values.',
  // BaseAutoComplete
  'itr-loading': 'Loading...',
  'itr-all-label': 'All {label}',
  'itr-all-selected': 'All Selected',
  'itr-plus-others': '(+{count} others)',
  'itr-apply': 'Apply',
};

const es = {
  // shared
  'itr-search': 'Buscar',
  'itr-delete': 'Eliminar',
  // BaseDialogBox
  'itr-close': 'Cerrar',
  'itr-save': 'Guardar',
  // BaseFilePreview
  'itr-preview': 'Vista previa',
  'itr-open-in-new-tab': 'Abrir en una nueva pestana',
  'itr-download': 'Descargar',
  'itr-preview-not-available': 'VISTA PREVIA NO DISPONIBLE',
  'itr-file-preview': 'Vista previa del archivo',
  // grid actions column
  'itr-actions': 'Acciones',
  // useValidationRules
  'itr-invalid-date-format':
    'Formato de fecha inválido. Use {format} y asegúrese de usar valores válidos.',
  'itr-attachment-size-limit': 'El archivo adjunto debe pesar menos de 50MB.',
  'itr-invalid-phone-number': 'Número de teléfono inválido. Use ###-###-####.',
  'itr-invalid-email': 'Correo electrónico inválido.',
  'itr-required': 'Obligatorio.',
  'itr-date-not-future': 'La fecha no puede estar en el futuro.',
  'itr-invalid-time-format':
    'Formato de hora inválido. Use dd:hh:mm y asegúrese de usar valores válidos.',
  // BaseAutoComplete
  'itr-loading': 'Cargando...',
  'itr-all-label': 'Todos {label}',
  'itr-all-selected': 'Todos seleccionados',
  'itr-plus-others': '(+{count} más)',
  'itr-apply': 'Aplicar',
};

const fr = {
  // shared
  'itr-search': 'Rechercher',
  'itr-delete': 'Supprimer',
  // BaseDialogBox
  'itr-close': 'Fermer',
  'itr-save': 'Enregistrer',
  // BaseFilePreview
  'itr-preview': 'Aperçu',
  'itr-open-in-new-tab': 'Ouvrir dans un nouvel onglet',
  'itr-download': 'Télécharger',
  'itr-preview-not-available': 'APERÇU NON DISPONIBLE',
  'itr-file-preview': 'Aperçu du fichier',
  // grid actions column
  'itr-actions': 'Actions',
  // useValidationRules
  'itr-invalid-date-format':
    'Format de date invalide. Utilisez {format} et assurez-vous de saisir des valeurs valides.',
  'itr-attachment-size-limit': 'La pièce jointe doit faire moins de 50 Mo.',
  'itr-invalid-phone-number': 'Numéro de téléphone invalide. Utilisez ###-###-####.',
  'itr-invalid-email': 'Courriel invalide.',
  'itr-required': 'Obligatoire.',
  'itr-date-not-future': 'La date ne peut pas être dans le futur.',
  'itr-invalid-time-format':
    "Format d'heure invalide. Utilisez dd:hh:mm et assurez-vous de saisir des valeurs valides.",
  // BaseAutoComplete
  'itr-loading': 'Chargement...',
  'itr-all-label': 'Tous {label}',
  'itr-all-selected': 'Tout sélectionné',
  'itr-plus-others': '(+{count} autres)',
  'itr-apply': 'Appliquer',
};

export default {
  en,
  es,
  fr,
  'fr-ca': fr, 
};
